let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lHrYe")).then(() => parcelRequire('j4MDr'));